<template>
    <div style="text-align: center">
        <img :src="imageSource" v-if="imageSource" style="max-width: 800px;" />
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import RedditAPI from "../RedditAPI";

export default Vue.defineComponent({
    data: function(){
        return {
            imageSource: ""
        };
    },
    methods: {
        loadData: async function(){
            let data = await RedditAPI.fetch();
            this.imageSource = data.image;
        }
    },
    beforeMount: function() {
        this.loadData();
    }
})
</script>